<template>
<a href="###" :class="current" :data-scp="scp" @click.prevent="jubao()">
	<i class="icon icon-report"></i><span>举报</span>
</a>
</template>
<script>
export default {
	props: ['current', 'scp']
	, methods: {
		jubao: function(){
//            maple.pageIns.changePage('/fittingShow/tipOff.html',{id:maple.url().params.buyerShowId})

			this.$dispatch('report');
		}
	}
};
</script>